import  { useState, useEffect } from "react";
import classNames from "classnames";

import useWindowDimensions from "../../_helpers/dimensions";
import "../../styles/slider.css";


export const SliderCarousel = ({ data }) => {
    
        const [currentIndx, setCurrentIndx] = useState(0);
        const [slideWidth, setSlideWidth] = useState(600);

        const imageCnt = data.length;

        
        const { width } = useWindowDimensions();
    
        useEffect(() => {
            width < 450 ? setSlideWidth(width) : setSlideWidth(600);
            
                const incr = setInterval(() => {
                    setCurrentIndx((indx) => indx + 1);
                }, 5000);
                if (currentIndx === imageCnt) {
                    setCurrentIndx(0);
                }
                return () => clearInterval(incr);
            
        },[width, currentIndx, imageCnt]);
    

  return (
    <div className="carousel-container">
        <div className="slide-pic-container">
        
            {data.map((imageUri,indx) => (
                <div className="box"
                    style={{
                        transform: `translateX(${-slideWidth * currentIndx}px)`,
                        transition: 'transform 1.2s ease'
                    }}
                    key={indx}
                >
                <img 
                    src={`/images/${imageUri}`} 
                    alt="" 
                    key={indx} 
                    className={classNames("slide-pic")}
                />
                </div>
            ))}

        </div>
    </div>
  )
}